import { Linking } from 'react-native'
import Svg, { Path, Rect } from 'react-native-svg'
import { Stack, Text, YStack } from 'tamagui'

import { useApp } from '../../../i18n'
import { Button } from '../../../ui'
import { qrPath } from '../qrPath'

const QR_SIZE = 260
/** Поле вокруг кода: без него сканеры читают заметно хуже. */
const QUIET = 4

export function Qr({ link, size = QR_SIZE }: { link: string; size?: number }) {
  const { size: modules, path } = qrPath(link)
  const total = modules + QUIET * 2

  return (
    <Svg testID="signing-qr" width={size} height={size} viewBox={`0 0 ${total} ${total}`}>
      <Rect x={0} y={0} width={total} height={total} fill="#fff" />
      <Path d={path} fill="#000" transform={`translate(${QUIET} ${QUIET})`} />
    </Svg>
  )
}

/**
 * Талон операции так, как его берут в руки: QR для экрана компьютера и кнопка для телефона.
 *
 * Код сканируют именно встроенным сканером приложения SIMA İmza: камера телефона и превью в
 * мессенджере открывают ссылку как веб-страницу и получают 404 с сайта SIMA — наш сервер
 * такого запроса даже не видит (проверено вживую 20.10.2026). На телефоне ту же операцию
 * открывает кнопка: схема `sima://` отдаёт ссылку приложению напрямую.
 *
 * Одно и то же нужно и сотруднику в портале, и контрагенту на публичной странице `/s/<токен>`,
 * поэтому блок живёт отдельно от карточек.
 */
export function SigningTicket({ link }: { link: string }) {
  const { t } = useApp()

  return (
    <YStack gap={12} alignItems="center">
      <Stack backgroundColor="#fff" padding={12} borderRadius={12}>
        <Qr link={link} />
      </Stack>
      <Text fontSize={13} color="$muted" textAlign="center">
        {t({
          ru: 'Откройте SIMA İmza и отсканируйте код встроенным сканером приложения',
          en: 'Open SIMA İmza and scan the code with the app’s built-in scanner',
          az: 'SIMA İmza tətbiqini açın və kodu tətbiqin daxili skaneri ilə oxudun',
        })}
      </Text>
      <Button onPress={() => Linking.openURL(link)}>
        {t({ ru: 'Открыть в приложении', en: 'Open in the app', az: 'Tətbiqdə aç' })}
      </Button>
    </YStack>
  )
}
